import {Box, Typography} from '@viptech/react-components'
import {useState} from 'react'
import zoomInIcon from 'src/images/zoomInIcon.svg'
import {LayoutTypes} from 'src/pages/camera-mosaic'
import styled from 'styled-components'

export type DetectionsToDisplay = {
  id: number
  createdAt: string
  croppedSrc: string
  imageSrc: string
  infos: Array<{title: string; value: string}>
  actionColor: string | undefined
}

type Props = {
  detections: DetectionsToDisplay
  layoutTypeId: number
}

export default function DetectionsList(props: Props) {
  const {detections, layoutTypeId} = props

  const handleColors = (detectionColor: string | undefined) => {
    let borderSize = '1'
    let borderColor = '#D0D5DD'
    let backgroundColor = '#D0D5DD20'
    let color = '#344054'

    if (detectionColor) {
      const strongerColor = detectionColor
      borderSize = '2'
      borderColor = strongerColor
      backgroundColor = strongerColor + '40'
      color = strongerColor
    }
    const border = `${borderSize}px solid ${borderColor}`

    return {border, backgroundColor, color}
  }

  const [isInDetailedMode, setIsInDetailedMode] = useState(false)
  const [isHoveringPhoto, setIsHoveringPhoto] = useState(false)
  const onMouseEnter = () => setIsHoveringPhoto(true)
  const onMouseLeave = () => setIsHoveringPhoto(false)

  const handleUnfocusPhoto = () => {
    setIsInDetailedMode(false)
    setIsHoveringPhoto(true)
  }

  return (
    <Box
      display='flex'
      border={handleColors(detections.actionColor).border}
      backgroundColor={handleColors(detections.actionColor).backgroundColor}
      borderRadius='8px'
      width='100%'
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}>
      {isInDetailedMode ? (
        <Box padding='10px' display='flex' align='center' style={{boxSizing: 'border-box'}} columnGap='15px' minHeight='122px' position='relative'>
          <img
            src={`${process.env.REACT_APP_EVENT_IMAGES_BASE_URL}/${detections.imageSrc}`}
            alt='contexto'
            width={'100%'}
            onClick={() => handleUnfocusPhoto()}
            style={{cursor: 'pointer'}}
          />
        </Box>
      ) : (
        <Box padding='10px' display='flex' align='center' style={{boxSizing: 'border-box'}} columnGap='15px' minHeight='122px' position='relative'>
          <ImageOnDetection
            src={`${process.env.REACT_APP_CROPPED_IMAGES_BASE_URL}/${detections.croppedSrc}`}
            layoutTypeId={layoutTypeId}
            alt='crop'
            onClick={() => setIsInDetailedMode(true)}
          />
          {isHoveringPhoto && (
            <Box
              position='absolute'
              left={layoutTypeId === LayoutTypes.LPR ? '20%' : '18%'}
              display='flex'
              align='center'
              justifyContent='center'
              onClick={() => setIsInDetailedMode(true)}>
              <img src={zoomInIcon} alt='zoom-in' width={20} height={16} style={{boxShadow: '0px 4px 8px rgba(0, 0, 0, 1)', cursor: 'pointer'}} />
            </Box>
          )}
          <Box display='flex' direction='column'>
            {detections.infos.map(({title, value}) => {
              return (
                <Typography variant='p' size='12px'>
                  <b>{title}:</b> {value}
                </Typography>
              )
            })}
          </Box>
        </Box>
      )}
    </Box>
  )
}

const ImageOnDetection = styled.img<{layoutTypeId: number}>`
  width: ${({layoutTypeId}) => (layoutTypeId === LayoutTypes.LPR ? '100px' : '80px')};
  height: ${({layoutTypeId}) => (layoutTypeId === LayoutTypes.LPR ? '60px' : '100px')};
  border-radius: 4px;
  aspect-ratio: 16/9;
  position: relative;
  cursor: pointer;
`
